export enum MessageEventsEnum {
    LISTEN_UPDATES = 'listen_updates',
}
